// extracted by mini-css-extract-plugin
export default {"FormTabs":"FormTabs_FormTabs__sGojE"};